import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Group summary='Properties' mdxType="Group">
    <Item title='identifier' subtitle='string' label='Required' mdxType="Item">
        ID of the payment method category to be used while loading the payment view. The possible values are:
        <ul>
        <li>klarna</li>
        <li>pay_later</li>
        <li>pay_now</li>
        <li>pay_over_time</li>
        <li>direct_bank_transfer</li>
        <li>direct_debit</li>
        </ul>
    </Item>
    <Item title='name' subtitle='string' label='Required' mdxType="Item">
        Name of the payment method category. These names are dynamic depending on what payment method is in the category. 
    </Item>
    <Item title='descriptiveAssetUrl' subtitle='string' label='Required' mdxType="Item">
        URL of the descriptive asset. Using this dynamic asset will make sure that changes from Klarna be automatically propagated.
    </Item>
    <Item title='standardAssetUrl' subtitle='boolean' label='Required' mdxType="Item">
        URL of the stadard asset. Using this dynamic asset will make sure that changes from Klarna be automatically propagated.
    </Item>
    </Group>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      